import { defineChain } from '@reown/appkit/networks'
import { AppKitNetwork } from '@reown/appkit/networks'

export const mttChain: AppKitNetwork = /*#__PURE__*/ defineChain({
  id: 6880,
  name: 'MTT Network',
  nativeCurrency: {
    name: 'mtt',
    symbol: 'MTT',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://evm-rpc.mtt.network'],
    },
  },
  blockExplorers: {
    default: {
      name: 'MTT Explorer',
      url: 'https://explorer.mtt.network',
      apiUrl: 'https://explorer.mtt.network/api/v2',
    },
  },
  chainNamespace: 'eip155',
  caipNetworkId: 'eip155:6880',
}) as AppKitNetwork
